/* Quiz Prohall — rotina ideal
 * QUESTIONS (abaixo) é o padrão. A seção pode sobrescrever título, subtítulo e o texto
 * das opções pelo editor de temas — o id de cada opção fica sempre aqui, nunca no admin.
 * Ao terminar, dispara: document 'prohall:quiz:complete' com { detail: payload }
 * e salva o payload em sessionStorage 'prohall_quiz'. O resultado (IA) será ligado depois.
 */
(function () {
  'use strict';

  var S = 'fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"';
  function svg(p) { return '<svg viewBox="0 0 32 32" ' + S + ' aria-hidden="true">' + p + '</svg>'; }

  var ICONS = {
    liso: svg('<path d="M10 5v22M16 5v22M22 5v22"/>'),
    ondulado: svg('<path d="M9 5c3 4-3 7 0 11s-3 7 0 11"/><path d="M16 5c3 4-3 7 0 11s-3 7 0 11"/><path d="M23 5c3 4-3 7 0 11s-3 7 0 11"/>'),
    cacheado: svg('<path d="M12 4c5 0 5 5 0 5s-5 5 0 5 5 5 0 5-5 5 0 5 5 4 1 4"/><path d="M21 4c5 0 5 5 0 5s-5 5 0 5 5 5 0 5-5 5 0 5 5 4 1 4"/>'),
    crespo: svg('<path d="M8 5l6 3-6 3 6 3-6 3 6 3-6 3 6 3"/><path d="M18 5l6 3-6 3 6 3-6 3 6 3-6 3 6 3"/>'),
    transicao: svg('<path d="M11 4v10c0 2 4 3 0 6s4 4 0 8"/><path d="M20 4v10c0 2 4 3 0 6s4 4 0 8"/><path d="M7 14h18" stroke-dasharray="2 3"/>'),
    oleoso: svg('<path d="M16 5c4 6 7 9 7 13a7 7 0 0 1-14 0c0-4 3-7 7-13z"/><path d="M13 19a3 3 0 0 0 3 3"/>'),
    normal: svg('<circle cx="16" cy="16" r="11"/><path d="M11 16.5l3.5 3.5L21 13"/>'),
    seco: svg('<path d="M16 5c4 6 7 9 7 13a7 7 0 0 1-14 0c0-4 3-7 7-13z"/><path d="M6 26L26 6"/>'),
    nao_sei: svg('<circle cx="16" cy="16" r="11"/><path d="M13 13a3 3 0 1 1 4.5 2.6c-1 .6-1.5 1.2-1.5 2.4"/><path d="M16 22h.01"/>'),
    poroso: svg('<path d="M16 4c4 6 7 9 7 13a7 7 0 0 1-14 0c0-4 3-7 7-13z"/><path d="M16 12v7M13 16.5l3 3 3-3"/><path d="M9 28h2M15 28h2M21 28h2"/>'),
    retem: svg('<path d="M16 4c4 6 7 9 7 13a7 7 0 0 1-14 0c0-4 3-7 7-13z"/><path d="M7 28h18"/>'),
    frizz: svg('<path d="M16 6c2 3-2 5 0 8s-2 5 0 8 0 4 0 4"/><path d="M9 8l-3-2M23 8l3-2M8 16H4M24 16h4M9 24l-3 2M23 24l3 2"/>'),
    danificado: svg('<path d="M8 4c2 4 0 6 2 9"/><path d="M12 17c2 4 0 7 2 11"/><path d="M7 15l6 1"/><path d="M20 4c2 4 0 6 2 9s0 7 2 11"/>'),
    ressecado: svg('<path d="M16 5c4 6 7 9 7 13a7 7 0 0 1-14 0c0-4 3-7 7-13z"/><path d="M12 17l3 2-2 3 3 2"/>'),
    queda: svg('<path d="M9 5c2 4-2 6 0 10"/><path d="M16 5c2 4-2 6 0 10"/><path d="M23 5c2 4-2 6 0 10"/><path d="M16 20v8M12.5 24.5L16 28l3.5-3.5"/>'),
    fino: svg('<path d="M16 4v24"/><path d="M8 16h4M20 16h4M10 13l-3 3 3 3M22 13l3 3-3 3"/>'),
    alisar: svg('<rect x="5" y="6" width="22" height="6" rx="2"/><path d="M8 12v12M12 12v14M16 12v14M20 12v14M24 12v12"/>'),
    loiro: svg('<circle cx="16" cy="16" r="5"/><path d="M16 4v3M16 25v3M4 16h3M25 16h3M7.5 7.5l2 2M22.5 22.5l2 2M7.5 24.5l2-2M22.5 9.5l2-2"/>'),
    cor: svg('<path d="M16 4c4 6 7 9 7 13a7 7 0 0 1-14 0c0-4 3-7 7-13z"/><path d="M11 19c2 3 8 3 10 0" stroke-dasharray="2 2.5"/>'),
    cachos: svg('<path d="M16 5a5 5 0 1 1 0 10 3.5 3.5 0 1 0 0 7 2 2 0 1 1 0 4"/><path d="M24 7l1.2 2.6L28 11l-2.8 1.2L24 15l-1.2-2.8L20 11l2.8-1.4z"/>'),
    nenhuma: svg('<path d="M16 4l10 4v7c0 7-4.5 11-10 13-5.5-2-10-6-10-13V8z"/><path d="M11.5 16l3 3 6-6"/>'),
    coloracao: svg('<path d="M16 4c4 6 7 9 7 13a7 7 0 0 1-14 0c0-4 3-7 7-13z"/><path d="M12 20a4 4 0 0 0 4 3"/>'),
    descoloracao: svg('<circle cx="16" cy="16" r="5"/><path d="M16 4v3M16 25v3M4 16h3M25 16h3M7.5 7.5l2 2M22.5 22.5l2 2M7.5 24.5l2-2M22.5 9.5l2-2"/>'),
    alisamento: svg('<path d="M10 5v22M16 5v22M22 5v22"/><path d="M6 11h20M6 21h20" stroke-dasharray="2 3"/>'),
    calor: svg('<path d="M16 4c1 5 7 7 7 14a7 7 0 0 1-14 0c0-4 2-6 4-8 0 3 1 5 3 5 0-4-2-7 0-11z"/>'),
    as_vezes: svg('<circle cx="16" cy="16" r="11"/><path d="M16 10v6l4 3"/>'),
    natural: svg('<path d="M7 25C7 13 14 7 26 6c0 12-6 19-18 19z"/><path d="M7 25l10-10"/>'),
    /* alternativas criadas no admin sem foto caem no ícone de mesma chave */
    brancos: svg('<path d="M10 5c2 5-2 9 0 14s-2 6 0 8"/><path d="M16 5c2 5-2 9 0 14s-2 6 0 8" stroke-dasharray="2 2.5"/><path d="M22 5c2 5-2 9 0 14s-2 6 0 8"/>'),
    recente: svg('<rect x="6" y="8" width="20" height="18" rx="3"/><path d="M6 13h20M11 5v5M21 5v5"/><path d="M12.5 19.5l2.5 2.5 4.5-5"/>'),
    coceira: svg('<path d="M5 22c4-3 7-3 11 0s7 3 11 0"/><path d="M10 8l2 6M16 6v8M22 8l-2 6"/>'),
    media: svg('<path d="M16 5c4 6 7 9 7 13a7 7 0 0 1-14 0c0-4 3-7 7-13z"/><path d="M12 19h8"/>'),
    lenta: svg('<path d="M16 5c4 6 7 9 7 13a7 7 0 0 1-14 0c0-4 3-7 7-13z"/><path d="M5 27c3-2 5-2 8 0s5 2 8 0 4-1 6 0"/>'),
    elastico: svg('<path d="M16 4v6"/><path d="M16 10c-5 2 5 4 0 6s5 4 0 6"/><path d="M16 22v6"/><path d="M11 7l5-3 5 3M11 25l5 3 5-3"/>'),
    pontas: svg('<path d="M16 4v14"/><path d="M16 18l-5 10M16 18l5 10M16 18v10"/>'),
    devagar: svg('<path d="M10 28V12M16 28V8M22 28V16"/><path d="M6 5h20" stroke-dasharray="2 3"/>'),
    secador: svg('<path d="M5 9h13a5 5 0 0 1 0 10H5z"/><path d="M13 19l-2 9h4l1-9"/><path d="M26 11h3M26 14h3M26 17h3"/>'),
    escova: svg('<rect x="11" y="3" width="10" height="15" rx="5"/><path d="M8 7h3M8 11h3M8 15h3M21 7h3M21 11h3M21 15h3"/><path d="M14 18h4v10h-4z"/>'),
    chapinha: svg('<path d="M10 4l3 24M22 4l-3 24"/><path d="M10 4h4l1 14M22 4h-4l-1 14"/>'),
    babyliss: svg('<path d="M16 4v6"/><rect x="13" y="10" width="6" height="18" rx="3"/><path d="M13 13c-4 1-4 3 0 4s-4 3 0 4 4 3 0 4"/>'),
    difusor: svg('<path d="M12 4h8v7h-8z"/><path d="M6 17a10 6 0 0 1 20 0v3H6z"/><path d="M10 24v3M16 24v3M22 24v3"/>'),
    especiais: svg('<path d="M16 4l3.5 7.5L27 12.5l-5.5 5.2L23 26l-7-4-7 4 1.5-8.3L5 12.5l7.5-1z"/>')
  };

  var NEEDS = [
    { id: 'frizz', icon: 'frizz', title: 'Frizz e umidade', desc: 'Fios arrepiados e volume fora de controle' },
    { id: 'danificado', icon: 'danificado', title: 'Cabelo danificado e quebradiço', desc: 'Fios elásticos, que quebram com facilidade' },
    { id: 'ressecado', icon: 'ressecado', title: 'Fios secos e sem brilho', desc: 'Ásperos, opacos e sem maciez' },
    { id: 'queda', icon: 'queda', title: 'Queda e enfraquecimento', desc: 'Mais fios caindo do que o normal' },
    { id: 'fino', icon: 'fino', title: 'Cabelo fino e sem volume', desc: 'Fios finos, sem corpo e sem densidade' },
    { id: 'alisar', icon: 'alisar', title: 'Volume e cabelo rebelde', desc: 'Quero alisar ou reduzir o volume' },
    { id: 'loiro', icon: 'loiro', title: 'Loiro amarelado', desc: 'O tom amarela com o tempo' },
    { id: 'cor', icon: 'cor', title: 'Cor que desbota', desc: 'A coloração perde intensidade rápido' },
    { id: 'cachos', icon: 'cachos', title: 'Cachos sem definição', desc: 'Os cachos não se formam ou desmancham' }
  ];

  var QUESTIONS = [
    {
      id: 'curvatura', type: 'single', layout: 'photos',
      title: 'Qual é o seu tipo de cabelo?',
      sub: 'Tem mais de um padrão no mesmo cabelo? Escolha o que aparece na maior parte.',
      options: [
        { id: 'liso', icon: 'liso', img: 'quiz-liso.jpg', title: 'Liso', desc: 'Sem ondas ou cachos definidos', code: '1A a 1C' },
        { id: 'ondulado', icon: 'ondulado', img: 'quiz-ondulado.jpg', title: 'Ondulado', desc: 'Ondas em S', code: '2A a 2C' },
        { id: 'cacheado', icon: 'cacheado', img: 'quiz-cacheado.jpg', title: 'Cacheado', desc: 'Cachos bem marcados', code: '3A a 3C' },
        { id: 'crespo', icon: 'crespo', img: 'quiz-crespo.jpg', title: 'Crespo', desc: 'Zigue-zague fechadinho', code: '4A a 4C' },
        { id: 'transicao', icon: 'transicao', img: 'quiz-transicao.jpg', title: 'Em transição', desc: 'Raiz natural, comprimento com química' }
      ]
    },
    {
      id: 'couro', apiId: 'couro_cabeludo', type: 'single', layout: 'list',
      title: 'Como é o seu couro cabeludo?',
      sub: 'Um couro cabeludo equilibrado é o começo de tudo. Ele define a limpeza da sua rotina.',
      options: [
        { id: 'oleoso', icon: 'oleoso', title: 'Oleoso', desc: 'A raiz fica oleosa rápido' },
        { id: 'normal', icon: 'normal', title: 'Equilibrado', desc: 'Nem oleoso, nem ressecado' },
        { id: 'seco', icon: 'seco', title: 'Seco ou sensível', desc: 'Repuxa, descama ou coça' },
        { id: 'nao_sei', icon: 'nao_sei', title: 'Não sei dizer', desc: 'Sem problema, a gente segue pelas outras respostas' }
      ]
    },
    {
      id: 'porosidade', type: 'single', layout: 'list',
      title: 'Seu cabelo absorve o produto e resseca rápido?',
      sub: 'Isso mostra a porosidade do fio e define se ele precisa de reposição e selagem.',
      options: [
        { id: 'alta', icon: 'poroso', title: 'Sim, absorve tudo', desc: 'O produto some no fio e logo ele resseca de novo' },
        { id: 'baixa', icon: 'retem', title: 'Não, ele segura bem', desc: 'O efeito dura de uma lavagem até a outra' },
        { id: 'nao_sei', icon: 'nao_sei', title: 'Não sei dizer', desc: 'Sem problema, a gente segue pelas outras respostas' }
      ]
    },
    {
      id: 'principal', apiId: 'incomodo_principal', group: 'incomodos', type: 'single', layout: 'list',
      title: 'O que mais te incomoda hoje?',
      sub: 'Escolha o principal. Na próxima tela você pode somar outros.',
      options: NEEDS
    },
    {
      id: 'extras', apiId: 'incomodos_extras', group: 'incomodos', type: 'multi', layout: 'list', optional: true, excludeFrom: 'principal',
      title: 'Tem mais alguma coisa?',
      sub: 'Opcional, e pode marcar mais de uma. Se só o anterior te incomoda, é só seguir.',
      options: NEEDS
    },
    {
      id: 'quimica', type: 'multi', layout: 'grid', exclusive: 'nenhuma',
      title: 'Seu cabelo já passou por alguma química?',
      sub: 'Mesmo que tenha sido há tempos, o histórico do fio muda o que ele precisa agora. Pode marcar mais de uma.',
      options: [
        { id: 'nenhuma', icon: 'nenhuma', title: 'Nenhuma', desc: 'Cabelo virgem' },
        { id: 'coloracao', icon: 'coloracao', title: 'Coloração', desc: 'Tinta, tonalizante ou henna' },
        { id: 'descoloracao', icon: 'descoloracao', title: 'Descoloração ou mechas', desc: 'Pó descolorante, luzes, platinado' },
        { id: 'alisamento', icon: 'alisamento', title: 'Alisamento', desc: 'Progressiva, escova ou botox' }
      ]
    },
    {
      id: 'calor', apiId: 'secagem', type: 'single', layout: 'list',
      title: 'Como você costuma secar o cabelo?',
      sub: 'Calor sem proteção tira água do fio e aumenta a quebra com o tempo.',
      options: [
        { id: 'sempre', icon: 'calor', img: 'quiz-op-calor.jpg', title: 'Uso secador, difusor ou prancha', desc: 'Sempre ou na maioria das vezes' },
        { id: 'as_vezes', icon: 'as_vezes', title: 'De vez em quando', desc: 'Só em ocasiões especiais' },
        { id: 'natural', icon: 'natural', title: 'Deixo secar naturalmente', desc: 'Sem fonte de calor' }
      ]
    }
  ];

  var CHECK = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7"/></svg>';
  var DOT = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="3.5" fill="currentColor"/></svg>';
  var BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>';
  var SPARK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.8 5.4L19 10l-5.2 1.6L12 17l-1.8-5.4L5 10l5.2-1.6z"/></svg>';

  var LOADING_MSGS = [
    'Lendo suas respostas…',
    'Analisando tipo de fio e porosidade…',
    'Buscando os produtos Prohall certos para você…',
    'Conferindo estoque e preços…',
    'Montando o passo a passo…',
    'Quase pronto…'
  ];
  var RESULT_KEY = 'prohall_quiz_result';
  var RESULT_TTL = 2 * 60 * 60 * 1000;

  var DEFAULT_TXT = {
    next: 'Continuar',
    finish: 'Ver minha rotina',
    text_next: 'Ver minha rotina',
    error_text: 'Não conseguimos montar sua rotina agora. Tente de novo em instantes.',
    error_timeout: 'Demorou mais que o esperado.',
    email_error: 'Confira o e-mail digitado.',
    error_title: 'Ops, algo deu errado',
    retry: 'Tentar de novo',
    result_title: 'Sua rotina Prohall está pronta',
    kit_full: 'Rotina completa',
    kit_tag: 'Kit',
    steps_with_kits: 'Ou monte passo a passo',
    steps_solo: 'Seu passo a passo',
    optional: 'opcional',
    in_routine: 'Na rotina',
    out_routine: 'Fora da rotina',
    howto: 'Como usar',
    tip: 'Dica',
    why: 'Por que para você',
    important: 'Importante',
    time_label: 'Tempo de ação',
    no_rinse: 'Não precisa enxaguar',
    unavailable: 'Indisponível',
    add: 'Adicionar',
    add_all: 'Adicionar rotina',
    adding: 'Adicionando…',
    added: 'Adicionado',
    toast_added: 'Produto adicionado à sacola. <a href="/cart">Ver sacola</a>',
    toast_error: 'Não foi possível adicionar: ',
    restart: 'Refazer o diagnóstico',
    disclaimer: 'Resultados podem variar conforme tipo de cabelo, porosidade, frequência e uso correto dos produtos.'
  };

  /* ---------- Configuração vinda dos blocos da seção ----------
   * Cada bloco imprime um JSON escondido; aqui viram perguntas e textos.
   * Nada salvo no admin = tudo cai nos padrões acima, que é o estado antigo.
   */
  function parseJson(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function readConfig(root) { return parseJson(root.querySelector('[data-phq-config]')) || {}; }

  function cloneOpt(o) {
    var c = {};
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) c[k] = o[k];
    return c;
  }

  function cloneQuestions() {
    return QUESTIONS.map(function (q) {
      var c = {};
      for (var k in q) if (Object.prototype.hasOwnProperty.call(q, k)) c[k] = q[k];
      c.options = q.options.map(cloneOpt);
      return c;
    });
  }

  /* Perguntas montadas no editor de temas, na ordem em que os blocos aparecem.
   * Pergunta sem título ou sem nenhuma alternativa é ignorada, para que um bloco
   * recém-adicionado e ainda vazio não derrube a tela. */
  function blocksFrom(root) {
    var host = root.querySelector('[data-phq-blocks]');
    if (!host) return null;
    var qs = [], usados = {}, anterior = null;
    var nodes = host.querySelectorAll('[data-phq-q]');
    for (var i = 0; i < nodes.length; i++) {
      var meta = parseJson(nodes[i].querySelector('[data-phq-q-meta]'));
      if (!meta || !meta.titulo || !meta.chave) continue;

      var opts = [], exclusiva = null;
      var crus = nodes[i].querySelectorAll('[data-phq-opt]');
      for (var k = 0; k < crus.length; k++) {
        var o = parseJson(crus[k]);
        if (!o || !o.titulo || !o.chave) continue;
        if (o.exclusiva) exclusiva = o.chave;
        opts.push({ id: o.chave, icon: o.chave, title: o.titulo, desc: o.desc || '', code: o.codigo || '', imgUrl: o.img || '', semArquivo: true });
      }
      if (!opts.length) continue;

      /* duas perguntas com o mesmo identificador misturariam as respostas */
      var id = meta.chave;
      while (usados[id]) id = meta.chave + '-' + (++usados[meta.chave]);
      usados[id] = 1;
      if (!usados[meta.chave]) usados[meta.chave] = 1;

      var q = {
        id: id, apiId: id, title: meta.titulo, sub: meta.sub || '',
        type: meta.tipo === 'multi' ? 'multi' : 'single',
        layout: meta.layout || 'list',
        options: opts
      };
      if (q.type === 'multi' && meta.opcional) q.optional = true;
      if (q.type === 'multi' && meta.maximo > 0) q.max = meta.maximo;
      if (exclusiva) q.exclusive = exclusiva;
      if (meta.so_da_anterior && anterior) q.onlyFrom = anterior;
      else if (meta.esconder_anterior && anterior) q.excludeFrom = anterior;
      qs.push(q);
      anterior = id;
    }
    return qs.length ? qs : null;
  }

  function questionsFrom(root) { return blocksFrom(root) || cloneQuestions(); }

  function textsFrom(root) {
    var src = parseJson(root.querySelector('[data-phq-textos]')) || {};
    var t = {};
    for (var k in DEFAULT_TXT) {
      if (!Object.prototype.hasOwnProperty.call(DEFAULT_TXT, k)) continue;
      t[k] = (src[k] != null && String(src[k]).length) ? String(src[k]) : DEFAULT_TXT[k];
    }
    return t;
  }

  function msgsFrom(cfg) {
    var m = cfg && cfg.carregando;
    return (m && m.length) ? m : LOADING_MSGS;
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function money(v) { try { return Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); } catch (e) { return 'R$ ' + Number(v).toFixed(2).replace('.', ','); } }
  function uid() { return 'quiz-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8); }

  function init(root) {
    var state = { step: -1, email: '', consent: false, answers: {}, text: '' };
    var cfg = readConfig(root);
    var QS = questionsFrom(root);
    var TXT = textsFrom(root);
    var MSGS = msgsFrom(cfg);
    var intro = root.querySelector('[data-phq-intro]');
    var qScreen = root.querySelector('[data-phq-question]');
    var done = root.querySelector('[data-phq-done]');
    var result = root.querySelector('[data-phq-result]');
    var consent = root.querySelector('[data-phq-consent]');
    var email = root.querySelector('[data-phq-email]');
    var emailErr = root.querySelector('[data-phq-email-error]');
    var startBtn = root.querySelector('[data-phq-start]');
    var bar = root.querySelector('[data-phq-bar]');
    var count = root.querySelector('[data-phq-count]');
    var back = root.querySelector('[data-phq-back]');
    var body = root.querySelector('[data-phq-body]');
    var total = QS.length;
    var assetBase = root.getAttribute('data-phq-asset-base') || '';
    var apiUrl = root.getAttribute('data-phq-api') || '';
    var apiToken = root.getAttribute('data-phq-token') || '';
    var empresaId = Number(root.getAttribute('data-phq-empresa') || 1);
    var loadTimer = null, progTimer = null, controller = null;

    /* o Liquid imprime o texto padrão; o bloco de textos troca aqui */
    ['[data-phq-email-error]', '[data-phq-error-title]', '[data-phq-retry]'].forEach(function (sel, i) {
      var el = root.querySelector(sel);
      if (el) el.textContent = [TXT.email_error, TXT.error_title, TXT.retry][i];
    });

    function fileFor(o) { return o.img || ('quiz-op-' + o.id.replace(/_/g, '-') + '.jpg'); }
    /* fileFor só vale para as perguntas que moram no JS: no admin, sem foto é sem foto,
     * senão o tema pediria um arquivo que nunca existiu e a opção nasceria quebrada. */
    function srcFor(o) {
      if (o.imgUrl) return o.imgUrl;
      if (o.semArquivo) return '';
      return assetBase ? assetBase + fileFor(o) : '';
    }
    function preload() {
      if (root.__phqPre) return; root.__phqPre = 1;
      QS.forEach(function (q) { q.options.forEach(function (o) { var src = srcFor(o); if (src) { var im = new Image(); im.src = src; } }); });
    }
    if ('requestIdleCallback' in window) requestIdleCallback(preload); else setTimeout(preload, 1500);

    function syncStart() { startBtn.disabled = !consent.checked; }
    consent.addEventListener('change', syncStart);
    syncStart();

    startBtn.addEventListener('click', function () {
      var v = email.value.trim();
      if (v && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { emailErr.hidden = false; email.focus(); return; }
      emailErr.hidden = true;
      state.email = v;
      state.consent = consent.checked;
      go(0);
    });

    back.addEventListener('click', function () { go(state.step - 1, -1); });

    function show(el) {
      [intro, qScreen, done, result].forEach(function (s) { if (s) s.hidden = s !== el; });
      var top = root.getBoundingClientRect().top + window.pageYOffset - 80;
      if (window.pageYOffset > top) window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }

    /* dir: 1 indo, -1 voltando. Pergunta que só repete o que marcaram na anterior
     * e ficou com uma opção (ou nenhuma) não tem o que perguntar: responde sozinha e segue. */
    function go(i, dir) {
      dir = dir || 1;
      if (i < 0) { state.step = -1; show(intro); return; }
      if (i >= total) { submit(); return; }
      var q = QS[i];
      if (q.onlyFrom) {
        var ops = optionsFor(q);
        if (ops.length <= 1) {
          if (q.type === 'multi') state.answers[q.id] = ops.map(function (o) { return o.id; });
          else if (ops.length) state.answers[q.id] = ops[0].id;
          else delete state.answers[q.id];
          go(i + dir, dir);
          return;
        }
      }
      state.step = i;
      render(q);
      show(qScreen);
    }

    function answersOf(id) {
      var a = state.answers[id];
      return Array.isArray(a) ? a : (a ? [a] : []);
    }

    function optionsFor(q) {
      if (q.onlyFrom) {
        var keep = answersOf(q.onlyFrom);
        return q.options.filter(function (o) { return keep.indexOf(o.id) > -1; });
      }
      if (!q.excludeFrom) return q.options;
      var ex = answersOf(q.excludeFrom);
      return q.options.filter(function (o) { return ex.indexOf(o.id) < 0; });
    }

    function isSel(q, id) {
      var a = state.answers[q.id];
      return q.type === 'multi' ? (a || []).indexOf(id) > -1 : a === id;
    }

    function render(q) {
      var i = state.step;
      bar.style.width = ((i + 1) / total * 100) + '%';
      count.textContent = (i + 1) + '/' + total;

      if (q.type === 'text') {
        body.innerHTML = '<h2 class="phq__q-title" tabindex="-1">' + esc(q.title) + '</h2>' +
          '<p class="phq__q-sub">' + esc(q.sub) + '</p>' +
          '<textarea class="phq__textarea" maxlength="500" rows="4" placeholder="' + esc(q.placeholder) + '" data-phq-text>' + esc(state.text) + '</textarea>' +
          '<div class="phq__actions"><button type="button" class="phq__btn phq__btn--block" data-phq-next>' + esc(TXT.text_next) + '</button></div>';
        var ta = body.querySelector('[data-phq-text]');
        ta.addEventListener('input', function () { state.text = ta.value; });
        body.querySelector('[data-phq-next]').addEventListener('click', function () { state.text = ta.value.trim(); go(i + 1); });
        var h0 = body.querySelector('.phq__q-title'); if (h0) h0.focus({ preventScroll: true });
        return;
      }

      if (q.type === 'multi' && !Array.isArray(state.answers[q.id])) state.answers[q.id] = [];
      var lista = optionsFor(q);
      if (q.excludeFrom || q.onlyFrom) {
        /* a anterior mudou: some o que não está mais na tela */
        var vale = lista.map(function (o) { return o.id; });
        if (q.type === 'multi') state.answers[q.id] = state.answers[q.id].filter(function (x) { return vale.indexOf(x) > -1; });
        else if (vale.indexOf(state.answers[q.id]) < 0) delete state.answers[q.id];
      }
      var multi = q.type === 'multi';
      var html = '<h2 class="phq__q-title" tabindex="-1">' + esc(q.title) + '</h2>' +
        '<p class="phq__q-sub">' + esc(q.sub) + '</p>' +
        '<div class="phq__opts' + (q.layout === 'grid' ? ' phq__opts--grid' : '') + (q.layout === 'photos' ? ' phq__opts--photos' : '') + '" style="--phq-n:' + Math.min(lista.length, 6) + '" role="group" aria-label="' + esc(q.title) + '">';
      lista.forEach(function (o) {
        var src = srcFor(o);
        var icone = ICONS[o.icon] || '';
        var media = src
          ? (q.layout === 'photos'
            ? '<span class="phq__photo"><img src="' + esc(src) + '" alt="" width="240" height="240"></span>'
            : '<span class="phq__icon phq__icon--img"><img src="' + esc(src) + '" alt=""></span>')
          : (icone ? '<span class="phq__icon">' + icone + '</span>' : '');
        html += '<button type="button" class="phq__opt" data-id="' + esc(o.id) + '" aria-pressed="' + isSel(q, o.id) + '">' +
          media +
          '<span class="phq__txt"><span class="phq__opt-title">' + esc(o.title) + '</span>' +
          (o.desc ? '<span class="phq__opt-desc">' + esc(o.desc) + '</span>' : '') +
          (o.code ? '<span class="phq__opt-desc" style="display:block;margin-top:2px">(' + esc(o.code) + ')</span>' : '') + '</span>' +
          '<span class="phq__mark' + (multi ? ' phq__mark--box' : '') + '">' + (multi ? CHECK : DOT) + '</span>' +
          '</button>';
      });
      html += '</div>';
      if (multi) {
        html += '<div class="phq__actions"><button type="button" class="phq__btn phq__btn--block" data-phq-next>' + esc(i === total - 1 ? TXT.finish : TXT.next) + '</button></div>';
      }
      body.innerHTML = html;
      var h = body.querySelector('.phq__q-title'); if (h) h.focus({ preventScroll: true });

      var next = body.querySelector('[data-phq-next]');
      function syncNext() { if (next) next.disabled = !q.optional && state.answers[q.id].length === 0; }
      syncNext();
      if (next) next.addEventListener('click', function () { go(i + 1); });

      body.querySelectorAll('.phq__opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-id');
          if (!multi) {
            state.answers[q.id] = id;
            body.querySelectorAll('.phq__opt').forEach(function (b) { b.setAttribute('aria-pressed', b === btn); });
            setTimeout(function () { go(i + 1); }, 220);
            return;
          }
          var arr = state.answers[q.id];
          var k = arr.indexOf(id);
          if (k > -1) arr.splice(k, 1);
          else {
            if (q.exclusive && id === q.exclusive) arr.length = 0;
            else if (q.exclusive) { var e = arr.indexOf(q.exclusive); if (e > -1) arr.splice(e, 1); }
            /* no limite, a mais antiga dá lugar à nova */
            if (q.max && arr.length >= q.max) arr.shift();
            arr.push(id);
          }
          body.querySelectorAll('.phq__opt').forEach(function (b) { b.setAttribute('aria-pressed', arr.indexOf(b.getAttribute('data-id')) > -1); });
          syncNext();
        });
      });
    }

    function opt(q, id) {
      for (var j = 0; j < q.options.length; j++) if (q.options[j].id === id) return q.options[j];
      return { id: id, title: id };
    }
    function descOf(o) { return [o.desc, o.code ? '(' + o.code + ')' : ''].filter(Boolean).join(' '); }

    function buildPayload() {
      var respostas = [];
      QS.forEach(function (q) {
        var a = state.answers[q.id];
        var r = { id: q.apiId || q.id, pergunta: q.title };
        if (q.type === 'text') {
          if (!state.text) return;
          r.tipo = 'texto'; r.resposta = state.text;
        } else if (q.type === 'multi') {
          r.tipo = 'multipla';
          r.resposta = (a || []).map(function (x) { var o = opt(q, x); return { valor: o.id, texto: o.title, descricao: descOf(o) }; });
          if (!r.resposta.length) return;
        } else {
          if (!a) return;
          var o = opt(q, a);
          r.tipo = 'unica'; r.resposta = { valor: o.id, texto: o.title, descricao: descOf(o) };
        }
        respostas.push(r);
      });
      return {
        empresa_id: empresaId,
        quiz: { id: 'quiz-rotina-capilar', nome: 'Diagnóstico capilar Prohall', versao: '2026-09-18' },
        sessao: state.sessao,
        respostas: respostas,
        opcoes: { min_produtos: 3, max_produtos: 5 }
      };
    }

    /* ---------- Envio e carregamento ---------- */
    var loadMsg = root.querySelector('[data-phq-load-msg]');
    var loadBar = root.querySelector('[data-phq-load-bar]');
    var loadBox = root.querySelector('[data-phq-loading]');
    var errBox = root.querySelector('[data-phq-error]');

    function startLoading() {
      loadBox.hidden = false; errBox.hidden = true;
      var m = 0, t0 = Date.now();
      loadMsg.textContent = MSGS[0];
      clearInterval(loadTimer); clearInterval(progTimer);
      loadTimer = setInterval(function () { m = Math.min(m + 1, MSGS.length - 1); loadMsg.textContent = MSGS[m]; }, 7000);
      progTimer = setInterval(function () {
        var s = (Date.now() - t0) / 1000;
        loadBar.style.width = Math.min(92, 100 * (1 - Math.exp(-s / 22))) + '%';
      }, 300);
    }
    function stopLoading() { clearInterval(loadTimer); clearInterval(progTimer); loadBar.style.width = '100%'; }

    function submit() {
      state.sessao = state.sessao || uid();
      var payload = buildPayload();
      try { sessionStorage.setItem('prohall_quiz', JSON.stringify(payload)); } catch (e) {}
      window.prohallQuiz = payload;
      document.dispatchEvent(new CustomEvent('prohall:quiz:complete', { detail: payload }));
      show(done);
      startLoading();
      if (!apiUrl) { fail('API não configurada.'); return; }
      if (controller) controller.abort();
      controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var to = setTimeout(function () { if (controller) controller.abort(); }, 120000);
      var headers = { 'Content-Type': 'application/json' };
      if (apiToken) headers.Authorization = 'Bearer ' + apiToken;
      fetch(apiUrl, { method: 'POST', headers: headers, body: JSON.stringify(payload), signal: controller ? controller.signal : undefined })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          clearTimeout(to);
          if (!res.ok || !res.j || !res.j.success || !res.j.data || !res.j.data.rotina) throw new Error((res.j && res.j.message) || 'Resposta inválida');
          stopLoading();
          try { sessionStorage.setItem(RESULT_KEY, JSON.stringify({ t: Date.now(), data: res.j.data })); } catch (e) {}
          renderResult(res.j.data);
        })
        .catch(function (err) { clearTimeout(to); fail(err && err.name === 'AbortError' ? TXT.error_timeout : ''); });
    }

    function fail(msg) {
      stopLoading();
      loadBox.hidden = true; errBox.hidden = false;
      var p = errBox.querySelector('[data-phq-error-msg]');
      p.textContent = (msg ? msg + ' ' : '') + TXT.error_text;
    }
    var retry = root.querySelector('[data-phq-retry]');
    if (retry) retry.addEventListener('click', submit);

    /* ---------- Resultado ---------- */
    function priceHtml(p) {
      return (p.preco_comparacao_texto ? '<s class="phr__old">' + esc(p.preco_comparacao_texto) + '</s> ' : '') +
        '<b class="phr__price">' + esc(p.preco_texto || money(p.preco)) + '</b>';
    }
    function addBtn(p, cls, label) {
      if (!p.disponivel || !p.shopify_variant_id) return '<span class="phr__na">' + esc(TXT.unavailable) + '</span>';
      return '<button type="button" class="' + cls + '" data-phr-add="' + esc(p.shopify_variant_id) + '">' + BAG + '<span>' + label + '</span></button>';
    }

    function renderResult(d) {
      var r = d.rotina || {}, passos = r.passos || [], kits = (r.kits || []);
      var diag = d.diagnostico || {};
      var h = '<div class="phr">';
      h += '<div class="phr__head">' +
        (diag.linha_principal ? '<span class="phr__pill">' + SPARK + '<span>' + esc(diag.linha_principal) + '</span></span>' : '') +
        '<h2 class="phr__title">' + esc(diag.titulo || TXT.result_title) + '</h2>' +
        (diag.resumo ? '<p class="phr__lead">' + esc(diag.resumo) + '</p>' : '') +
        '</div>';

      h += '<div class="phr__grid' + (kits.length ? '' : ' phr__grid--solo') + '">';
      if (kits.length) {
        h += '<aside class="phr__kits">';
        kits.forEach(function (k, idx) {
          var all = k.cobre_passos && k.cobre_passos.length >= passos.length;
          h += '<article class="phr-kit' + (idx === 0 ? ' phr-kit--main' : '') + '">' +
            '<span class="phr-kit__tag">' + esc(all ? TXT.kit_full : (k.rotulo || TXT.kit_tag)) + '</span>' +
            '<h3 class="phr-kit__name">' + esc(k.nome) + '</h3>' +
            (k.motivo ? '<p class="phr-kit__why">' + esc(k.motivo) + '</p>' : '') +
            '<div class="phr-kit__row">' + (k.imagem_url ? '<img src="' + esc(img(k.imagem_url, 160)) + '" alt="" loading="lazy">' : '') +
            '<div>' + priceHtml(k) + '</div></div>' +
            addBtn(k, 'phr__btn phr__btn--solid', TXT.add) +
            '</article>';
        });
        h += '</aside>';
      }

      h += '<div class="phr__steps">' +
        '<div class="phr__label"><span>' + esc(kits.length ? TXT.steps_with_kits : TXT.steps_solo) + '</span></div>';
      passos.forEach(function (p) {
        var on = !!(p.disponivel && p.shopify_variant_id);
        var meta = [];
        if (p.tempo_de_acao) meta.push(TXT.time_label + ': ' + p.tempo_de_acao);
        if (p.enxaguar === false) meta.push(TXT.no_rinse);
        h += '<article class="phr-step" data-phr-step="' + esc(p.shopify_variant_id || '') + '" data-price="' + (Number(p.preco) || 0) + '" data-on="' + on + '">' +
          '<header class="phr-step__head">' +
            '<span class="phr-step__n">' + esc(p.passo) + '</span>' +
            '<div class="phr-step__t"><h3>' + esc(p.titulo_etapa || p.etapa) + (p.essencial === false ? ' <em>' + esc(TXT.optional) + '</em>' : '') + '</h3>' +
            (p.frequencia ? '<p>' + esc(p.frequencia) + '</p>' : '') + '</div>' +
            (on ? '<button type="button" class="phr-step__toggle" aria-pressed="true" data-phr-toggle>' + CHECK + '<span>' + esc(TXT.in_routine) + '</span></button>' : '') +
          '</header>' +
          '<div class="phr-step__prod">' +
            (p.imagem_url ? '<a href="' + esc(p.url_produto || '#') + '" class="phr-step__img" target="_blank" rel="noopener"><img src="' + esc(img(p.imagem_url, 160)) + '" alt="" loading="lazy"></a>' : '') +
            '<div class="phr-step__info"><a href="' + esc(p.url_produto || '#') + '" target="_blank" rel="noopener" class="phr-step__name">' + esc(p.nome) + '</a>' +
            '<div>' + priceHtml(p) + '</div></div>' +
            addBtn(p, 'phr__btn phr__btn--line', TXT.add) +
          '</div>' +
          '<div class="phr-step__how">' +
            '<span class="phr-step__label">' + esc(TXT.howto) + '</span>' +
            (p.modo_de_uso ? '<p>' + esc(p.modo_de_uso) + '</p>' : '') +
            (meta.length ? '<p class="phr-step__meta">' + esc(meta.join(' · ')) + '</p>' : '') +
            (p.dica ? '<p><b>' + esc(TXT.tip) + ':</b> ' + esc(p.dica) + '</p>' : '') +
            (p.motivo ? '<p class="phr-step__why"><b>' + esc(TXT.why) + ':</b> ' + esc(p.motivo) + '</p>' : '') +
          '</div>' +
          '</article>';
      });
      h += '</div></div>';

      if (d.observacoes) h += '<div class="phr__obs"><b>' + esc(TXT.important) + ':</b> ' + esc(d.observacoes) + '</div>';
      h += '<p class="phr__disc">' + esc(TXT.disclaimer) + '</p>';
      h += '<p class="phr__again"><button type="button" class="phq__link" data-phr-restart>' + esc(TXT.restart) + '</button></p>';
      h += '<div class="phr__bar" data-phr-bar><div><span data-phr-count></span><b data-phr-total></b></div>' +
        '<button type="button" class="phr__btn phr__btn--solid phr__btn--bar" data-phr-all>' + BAG + '<span>' + esc(TXT.add_all) + '</span></button></div>';
      h += '<div class="phr__toast" data-phr-toast hidden></div>';
      h += '</div>';

      result.innerHTML = h;
      result.__data = d;
      show(result);
      bindResult(d);
      updateBar();
    }

    function stepsOn() {
      return Array.prototype.filter.call(result.querySelectorAll('[data-phr-step]'), function (s) { return s.getAttribute('data-on') === 'true'; });
    }
    function updateBar() {
      var on = stepsOn(), sum = 0;
      on.forEach(function (s) { sum += Number(s.getAttribute('data-price')) || 0; });
      var c = result.querySelector('[data-phr-count]'), t = result.querySelector('[data-phr-total]'), b = result.querySelector('[data-phr-all]');
      if (!c) return;
      c.textContent = on.length + (on.length === 1 ? ' item na rotina' : ' itens na rotina');
      t.textContent = money(sum);
      b.disabled = on.length === 0;
    }

    var toastT = null;
    function toast(html) {
      var el = result.querySelector('[data-phr-toast]'); if (!el) return;
      el.innerHTML = html; el.hidden = false;
      clearTimeout(toastT); toastT = setTimeout(function () { el.hidden = true; }, 5000);
    }

    /**
     * Soma no contador do header sem esperar a rede.
     *
     * Medido na loja: /cart/add.js ~1,0s e /cart.js ~1,0s. Esperar os dois para
     * só então mexer no número deixava o header parado por ~2s depois do
     * clique. O add já voltou com sucesso, então a quantidade entrou — dá para
     * somar na hora e deixar o syncTheme reconciliar logo atrás.
     *
     * A resposta do /cart/add.js traz só { items: [...] }, sem item_count, por
     * isso a soma é feita a partir do que está na tela.
     */
    function bumpCount(n) {
      if (!n) return;
      try {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          var atual = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
          if (!isNaN(atual)) el.textContent = atual + n;
        });
      } catch (e) {}
    }

    /**
     * Depois de escrever no carrinho, a tela do TEMA precisa saber.
     *
     * O drawer do Halo não escuta nada sozinho: o AJAX dele só troca
     * .previewCart-wrapper, e o contador do header fica de fora. Antes daqui o
     * quiz disparava só um 'cart:refresh' — evento que NINGUÉM do tema escuta.
     * O item entrava no carrinho de verdade, mas a tela seguia mostrando o
     * número antigo até a pessoa abrir a gaveta na mão.
     *
     * Mesmo caminho que o assets/sofia-widget.js já usa: chamar as funções do
     * tema na mão, corrigir o contador como rede de segurança e só então
     * disparar 'cart-update', que é o evento de verdade (cart-drawer-v3.js e
     * halo-toolcart.js escutam).
     */
    function syncTheme() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var halo = window.halo;
          try { if (halo && typeof halo.updateCart === 'function') halo.updateCart(cart); } catch (e) {}
          try { if (halo && typeof halo.updateSidebarCart === 'function') halo.updateSidebarCart(cart); } catch (e) {}

          /* Rede de segurança: se essas funções sumirem do tema, pelo menos o
             contador do header não fica mentindo. */
          try {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            if (window.cartStrings) {
              document.querySelectorAll('[data-cart-text]').forEach(function (el) {
                el.textContent = cart.item_count === 1 ? window.cartStrings.item : window.cartStrings.items;
              });
            }
            /* A barra de frete grátis do drawer se redesenha no 'change'. */
            document.querySelectorAll('[data-free-shipping-wrapper]').forEach(function (el) {
              el.dispatchEvent(new Event('change', { bubbles: true }));
            });
          } catch (e) {}

          try { document.dispatchEvent(new CustomEvent('cart-update', { detail: cart })); } catch (e) {}
          return cart;
        })
        .catch(function () { return null; });
    }

    function cartAdd(ids) {
      var d = result.__data || {};
      var items = ids.map(function (id) { return { id: Number(id), quantity: 1, properties: { _origem: 'Quiz Prohall' } }; });
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j && (j.description || j.message) || 'Erro'); return j; }); })
        .then(function (j) {
          /* Os atributos vão SEM await, de propósito. Medido na loja: o
             /cart/update.js leva ~2,6s, contra ~500ms do /cart.js. Esperar por
             ele só para depois atualizar o contador fazia o número do header
             demorar ~4,6s para mexer — tempo em que a pessoa acha que o clique
             não funcionou e clica de novo.
             Atributo não altera item_count nem as linhas do carrinho, então o
             syncTheme pode ler o /cart.js sem esperar por isto. */
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { quiz_sessao: d.sessao || state.sessao || '', quiz_linha: (d.diagnostico && d.diagnostico.linha_principal) || '' } }) }).catch(function () {});

          /* O número mexe agora; o syncTheme confere e corrige logo atrás,
             então uma divergência (outra aba mexendo no carrinho) dura ~1s. */
          bumpCount(ids.length);

          syncTheme().then(function () {
            /* Mantido por compatibilidade com quem já escutava. */
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          });
          document.dispatchEvent(new CustomEvent('prohall:quiz:cart', { detail: { items: ids } }));

          /* Não espera o sync: o botão pode dizer "Adicionado" imediatamente. */
          return j;
        });
    }

    function bindResult() {
      result.querySelectorAll('[data-phr-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.closest('[data-phr-step]');
          var on = btn.getAttribute('aria-pressed') !== 'true';
          btn.setAttribute('aria-pressed', on);
          btn.querySelector('span').textContent = on ? TXT.in_routine : TXT.out_routine;
          step.setAttribute('data-on', on);
          step.classList.toggle('is-off', !on);
          updateBar();
        });
      });
      result.querySelectorAll('[data-phr-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var label = btn.querySelector('span'), old = label.textContent;
          btn.disabled = true; label.textContent = TXT.adding;
          cartAdd([btn.getAttribute('data-phr-add')]).then(function () {
            label.textContent = TXT.added; btn.classList.add('is-done');
            toast(TXT.toast_added);
            setTimeout(function () { btn.disabled = false; label.textContent = old; btn.classList.remove('is-done'); }, 2500);
          }).catch(function (e) {
            btn.disabled = false; label.textContent = old;
            toast(esc(TXT.toast_error) + esc(e.message || ''));
          });
        });
      });
      var all = result.querySelector('[data-phr-all]');
      if (all) all.addEventListener('click', function () {
        var ids = stepsOn().map(function (s) { return s.getAttribute('data-phr-step'); }).filter(Boolean);
        if (!ids.length) return;
        var label = all.querySelector('span');
        all.disabled = true; label.textContent = TXT.adding;
        cartAdd(ids).then(function () { window.location.href = '/cart'; })
          .catch(function (e) { all.disabled = false; label.textContent = TXT.add_all; toast(esc(TXT.toast_error) + esc(e.message || '')); });
      });
      var rs = result.querySelector('[data-phr-restart]');
      if (rs) rs.addEventListener('click', restart);
    }

    function restart() {
      try { sessionStorage.removeItem(RESULT_KEY); } catch (e) {}
      state.answers = {}; state.text = ''; state.sessao = null;
      result.innerHTML = '';
      go(0);
    }

    /* Se a pessoa voltar para a página, mostra a última rotina (até 2h) */
    try {
      var saved = JSON.parse(sessionStorage.getItem(RESULT_KEY) || 'null');
      if (saved && saved.data && Date.now() - saved.t < RESULT_TTL) { state.sessao = saved.data.sessao; renderResult(saved.data); }
    } catch (e) {}
  }

  function boot() { document.querySelectorAll('[data-prohall-quiz]').forEach(function (r) { if (!r.__phq) { r.__phq = 1; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
